import {
    SchoolSpotAction,
    ADD_SPOT
} from '../actions/SchoolSpotActions';
import { StoreState } from '../types';
import { Epic, combineEpics } from 'redux-observable';
import { firebaseStore, firebaseStorage } from '../firebase';
import { createTryActionsEpic } from './Common';
import _ from 'lodash';

const schoolSpotDocs = (schoolId: string) =>
    firebaseStore.collection('schools').doc(schoolId).collection('spots');

const addSpotDoc = async (schoolId: string, { auth, schoolSpots }: StoreState) => {
    const user = auth.user;
    if (!user || !user.uid) {
        throw new Error('Tried to add a spot without authenticating');
    }

    if (!schoolId) {
        throw new Error('Invalid schoolId');
    }

    const form = schoolSpots.newSpotForm;

    if (!form) {
        throw new Error('Invalid form');
    }

    if (!form.name || form.name.length < 3) {
        throw new Error(`Invalid name: ${form.name}`);
    }

    if (!form.description || form.description.length < 3) {
        throw new Error(`Invalid description: ${form.description}`);
    }

    if (!form.lat || !form.lng) {
        throw new Error(`Invalid lat/lng: ${form.lat}/${form.lng}`);
    }

    // save photo to storage and get URL
    let photoURL = '';
    if (form.name && form.photoFile && form.photoFile.name) {
        const ext = _.last(form.photoFile.name.split('.'));
        if (ext) {
            const fileName = form.name.toLowerCase().replace(/ /g, '-');
            const ref = firebaseStorage.ref().child(`schools/${schoolId}/images/spots/${fileName}.${ext}`);
            const snapshot = await ref.put(form.photoFile);
            photoURL = await snapshot.ref.getDownloadURL();
        }
    }

    let doc = {};
    const saveForm = _.omit(form, 'photoFile', 'id');
    if (photoURL) {
        doc = {
            ...saveForm,
            photoURL,
            schoolId
        };
    } else {
        doc = {
            ...saveForm,
            schoolId
        };
    }

    if (form.id) {
        return await schoolSpotDocs(schoolId).doc(form.id).set(doc, { merge: true });
    }

    return await schoolSpotDocs(schoolId).add(doc);
};

const addSpotEpic: Epic<SchoolSpotAction, SchoolSpotAction, StoreState> =
    createTryActionsEpic(
        ADD_SPOT,
        (a, s) => addSpotDoc(a.value.schoolId, s),
        (a, r) => a.value);

export default combineEpics<SchoolSpotAction, SchoolSpotAction, StoreState>(addSpotEpic);
